/**
 * Keys for Miter-first-party and Agave-backed ERP/accounting integrations.
 * Merged from non-Agave integrations and `AGAVE_INTEGRATION_KEY_VALUES` in the backend;
 * keep in sync when adding a new integration key.
 */
const NON_AGAVE_INTEGRATION_KEY_VALUES = [
  "qbo",
  "qbd",
  "procore",
  "guideline",
  "sage_300",
  "sage_100",
  "sage_intacct",
  "jonas",
  "xero",
  "contractors_plan",
  "wbs",
  "employee_navigator",
  "checkr",
  "bamboo",
  "buildops",
  "payroll_integrations",
  "astrada",
  "comdata",
  "assignar",
  "netsuite",
  "hcss",
  "workramp",
  "service_titan",
  "jde",
  "cmic",
  "benbase",
] as const;

const AGAVE_INTEGRATION_KEY_VALUES = [
  "vista",
  "spectrum",
  "foundation",
  "acumatica",
  "sage_300",
  "sage_100",
] as const;

const PUBLIC_MITER_INTEGRATION_KEY_VALUES = [
  ...NON_AGAVE_INTEGRATION_KEY_VALUES,
  ...AGAVE_INTEGRATION_KEY_VALUES,
] as const;

const ALL_MITER_INTEGRATION_KEY_VALUES = [...PUBLIC_MITER_INTEGRATION_KEY_VALUES, "stripe"] as const;

export type MiterIntegrationKey = (typeof ALL_MITER_INTEGRATION_KEY_VALUES)[number];

export const MITER_INTEGRATION_KEY_VALUES: [MiterIntegrationKey, ...MiterIntegrationKey[]] = [
  ...PUBLIC_MITER_INTEGRATION_KEY_VALUES,
];

// TODO: migrate out of @miter/types (functions don't belong here)
// oxlint-disable-next-line local/restricted-syntax
export const isMiterIntegrationKey = (val: string): val is MiterIntegrationKey => {
  return (ALL_MITER_INTEGRATION_KEY_VALUES as readonly string[]).includes(val);
};
